import React from 'react';
import './ClientsCarousel.css';

function ClientsCarousel() {
  const clients = [
    { name: "MAS Bodyline", logoUrl: "https://logo.clearbit.com/masholdings.com" },
    { name: "Benji (pvt) LTD", logoUrl: "https://logo.clearbit.com/oniverse.it" },
    { name: "Double Tree By Hilton", logoUrl: "https://logo.clearbit.com/hilton.com" },
    { name: "Silver Ray Hotel - Rathnapura", logoUrl: "https://logo.clearbit.com/silverray.lk" },
    { name: "Ceylon Electricity Board", logoUrl: "https://logo.clearbit.com/ceb.lk" }
  ];

  return (
    <section className="clients-carousel-section section">
      <div className="container text-center">
        <h2 className="section-title">Trusted By Industry Leaders</h2>
        <p className="trust-intro">
          Our clientele ranges from critical infrastructure providers to global manufacturing brands operating in Sri Lanka. 
          We maintain strict confidentiality regarding our security clients while demonstrating unrivaled safety metrics.
        </p>
        <div className="clients-logo-grid mt-3">
          {clients.map((client, index) => (
            <div key={index} className="client-logo-card hover-lift">
              <div className="client-icon">
                <img 
                  src={client.logoUrl} 
                  alt={client.name} 
                  style={{ width: '80px', height: '80px', objectFit: 'contain', borderRadius: '8px' }} 
                  onError={(e) => { 
                    e.target.onerror = null; 
                    e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(client.name)}&background=f8f9fa&color=333&size=128`; 
                  }} 
                />
              </div>
              <h4>{client.name}</h4>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ClientsCarousel;
